// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8e975e55","455":"1d2be81e"}[chunkId] + ".chunk.js";
};